module.exports = __webpack_public_path__ + "img/blessing.44d446ee.jpeg";